import React from 'react';

export interface StepUpState {
  token: string | null;
  expiresAt: Date | null;
  /** Wall-clock validity check evaluated at call time — use this rather than testing `token`/`expiresAt` directly. */
  getIsValid: () => boolean;
  requestStepUp: () => Promise<void>;
  setToken: (token: string, expiresAt: string) => void;
  clearToken: () => void;
}

export const StepUpContext = React.createContext<StepUpState | null>(null);
